import { User } from '@adsk/alloy-provider';
import { fetchRfiService as fetchWithToken } from '../utils/fetchRfiService';
import { getApiBaseUrl } from '../config';
import { headers, HttpMethod } from '../constants';
import { CreateSDKConfig } from './types';
import { WorkflowRole } from '../types/common/enums';

const ExternalUsersApi = ({ projectId }: CreateSDKConfig) => {
  const url = `${getApiBaseUrl(projectId)}/external-users`;
  return {
    addNonMember(email: string, rolesToGrant?: WorkflowRole[]): Promise<Record<string, never>> {
      const roles: { role: WorkflowRole }[] | null =
        rolesToGrant && rolesToGrant.length >= 1 ? rolesToGrant.map((role) => ({ role })) : null;
      return fetchWithToken(url, {
        method: HttpMethod.Post,
        body: JSON.stringify({
          email,
          ...(roles ? { roles } : {}),
        }),
        headers,
      });
    },
    getNonMember(email: string): Promise<User> {
      return fetchWithToken(`${url}?email=${encodeURIComponent(email)}`);
    },
  };
};

export default ExternalUsersApi;
